import { LCurrencyEnum } from '@winelidays/wld-tsx-2/types';
/* TEMP until backend mangagement of currencies */
export const CURRENCIES = [
    { _key: LCurrencyEnum.Eur, name: 'euro', symbol: '€' },
    { _key: LCurrencyEnum.Usd, name: 'dollar', symbol: '$' },
    { _key: LCurrencyEnum.Gbp, name: 'pound', symbol: '£' }
];
/**
 * INITIAL CONTEXT
 */
export const INITIAL_I18N_CONTEXT = {
    translate: null,
    currency: CURRENCIES[0]
};
